"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var observables_1 = require("./observables");
var click_1 = require("./observables/click");
var misc_1 = require("./utils/misc");
var Positionable = /** @class */ (function (_super) {
    __extends(Positionable, _super);
    function Positionable(props) {
        var _this = _super.call(this, props) || this;
        _this.refHandlers = {
            container: React.createRef(),
            dnd: React.createRef(),
            neRotate: React.createRef(),
            seRotate: React.createRef(),
            swRotate: React.createRef(),
            nwRotate: React.createRef(),
            nResize: React.createRef(),
            neResize: React.createRef(),
            eResize: React.createRef(),
            seResize: React.createRef(),
            sResize: React.createRef(),
            swResize: React.createRef(),
            wResize: React.createRef(),
            nwResize: React.createRef(),
        };
        _this.destroy$ = new rxjs_1.Subject();
        /**
         * Call `onUpdate()` prop if position has changed.
         */
        _this.handleUpdate = function () {
            if (!_this.props.onUpdate ||
                misc_1.objectsAreEqual(_this.state, _this.props.position)) {
                return;
            }
            _this.props.onUpdate(_this.state);
        };
        _this.state = __assign({}, props.position);
        return _this;
    }
    Positionable.prototype.componentDidMount = function () {
        this.buildSubscriptions();
    };
    Positionable.prototype.componentWillUnmount = function () {
        this.destroy$.next();
    };
    /**
     * Update subscriptions and internal Position if the props change.
     */
    Positionable.prototype.componentDidUpdate = function (prevProps) {
        if (misc_1.objectsAreEqual(this.props, prevProps)) {
            return;
        }
        var _a = this.props, position = _a.position, rest = __rest(_a, ["position"]);
        var prevPosition = prevProps.position, prevRest = __rest(prevProps, ["position"]);
        if (!misc_1.objectsAreEqual(position, prevPosition)) {
            this.setState(this.props.position);
        }
        if (!misc_1.objectsAreEqual(rest, prevRest)) {
            this.buildSubscriptions();
        }
    };
    Positionable.prototype.render = function () {
        var _a = this.props, children = _a.children, render = _a.render;
        var passedProps = {
            renderedPosition: this.state,
            refHandlers: this.refHandlers,
        };
        if (misc_1.isFunction(render)) {
            return render(passedProps);
        }
        if (misc_1.isFunction(children)) {
            return children(passedProps);
        }
        throw new Error('Positionable must receive `render` or `children` as render callback');
    };
    /**
     * Handle subscribing to and unsubscribing from Observables.
     */
    Positionable.prototype.buildSubscriptions = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, disableKeyboardMovement = _a.disableKeyboardMovement, movable = _a.movable, onClick = _a.onClick, resizable = _a.resizable, rotatable = _a.rotatable, snapTo = _a.snapTo, snapXTo = _a.snapXTo, snapYTo = _a.snapYTo;
        var _b = this.state, left = _b.left, width = _b.width;
        var group = this.props.group || misc_1.randomString();
        this.destroy$.next();
        // We need, at the bare minimum, a `container` ref.
        if (!this.refHandlers.container.current) {
            return;
        }
        if (onClick) {
            click_1.createClickObservable({
                element: this.refHandlers.dnd.current ||
                    this.refHandlers.container.current,
            })
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe(onClick);
        }
        // If `disabled`, only the click observable will be created.
        if (disabled) {
            return;
        }
        if (movable) {
            observables_1.createDndObservable({
                element: this.refHandlers.container.current,
                group: group,
                handle: this.refHandlers.dnd.current ||
                    this.refHandlers.container.current,
                snapTo: snapTo,
                snapXTo: snapXTo,
                snapYTo: snapYTo,
            })
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe();
            observables_1.createAllMoveObservable({
                element: this.refHandlers.container.current,
                group: group,
                onComplete: this.handleUpdate,
                shouldConvertToPercent: left.includes('%'),
            })
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe(function (newCoords) { return _this.setState(newCoords); });
            if (!disableKeyboardMovement) {
                observables_1.createKeyboardMoveObservable({
                    element: this.refHandlers.container.current,
                    onComplete: this.handleUpdate,
                    shouldConvertToPercent: left.includes('%'),
                })
                    .pipe(operators_1.takeUntil(this.destroy$))
                    .subscribe(function (newCoords) { return _this.setState(newCoords); });
            }
        }
        if (resizable) {
            var resizeObservableConfigs = misc_1.calculateResizeObservableConfigs();
            resizeObservableConfigs.forEach(function (config) {
                var handle = _this.refHandlers[config.refHandlerName].current;
                if (!handle) {
                    return;
                }
                observables_1.createResizeObservable({
                    element: _this.refHandlers.container.current,
                    handle: handle,
                    onComplete: _this.handleUpdate,
                    top: config.top,
                    right: config.right,
                    bottom: config.bottom,
                    left: config.left,
                    shouldConvertToPercent: width.includes('%'),
                    snapTo: snapTo,
                    snapXTo: snapXTo,
                    snapYTo: snapYTo,
                })
                    .pipe(operators_1.takeUntil(_this.destroy$))
                    .subscribe(function (newPosition) { return _this.setState(newPosition); });
            });
        }
        if (rotatable) {
            var rotateObservableConfigs = misc_1.calculateRotateObservableConfigs();
            rotateObservableConfigs.forEach(function (config) {
                var handle = _this.refHandlers[config.refHandlerName].current;
                if (!handle) {
                    return;
                }
                observables_1.createRotateObservable({
                    element: _this.refHandlers.container.current,
                    handle: handle,
                    onComplete: _this.handleUpdate,
                })
                    .pipe(operators_1.takeUntil(_this.destroy$))
                    .subscribe(function (newRotation) { return _this.setState(newRotation); });
            });
        }
    };
    Positionable.defaultProps = {
        resizable: [],
    };
    return Positionable;
}(React.Component));
exports.Positionable = Positionable;
exports.default = Positionable;
//# sourceMappingURL=Positionable.js.map